module.exports = __webpack_public_path__ + "img/206e6f2.jpg";